var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProbabilitySferics01 = function SvgProbabilitySferics01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 701.97 559.99",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "probability_sferics-01_svg2__a",
    x1: 17.04,
    x2: 509.04,
    y1: 296.01,
    y2: -98.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_sferics-01_svg2__a",
    id: "probability_sferics-01_svg2__b",
    x1: 70.85,
    x2: 562.85,
    y1: 363.04,
    y2: -31.96
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_sferics-01_svg2__a",
    id: "probability_sferics-01_svg2__c",
    x1: -30.6,
    x2: 461.4,
    y1: 236.68,
    y2: -158.32
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_sferics-01_svg2__a",
    id: "probability_sferics-01_svg2__d",
    x1: 238.8,
    x2: 730.8,
    y1: 572.23,
    y2: 177.23
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_sferics-01_svg2__a",
    id: "probability_sferics-01_svg2__e",
    x1: 216.61,
    x2: 708.61,
    y1: 544.59,
    y2: 149.59
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_sferics-01_svg2__a",
    id: "probability_sferics-01_svg2__f",
    x1: 307.78,
    x2: 799.78,
    y1: 658.15,
    y2: 263.15
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_sferics-01_svg2__a",
    id: "probability_sferics-01_svg2__g",
    x1: 260.99,
    x2: 752.99,
    y1: 599.87,
    y2: 204.87
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_sferics-01_svg2__a",
    id: "probability_sferics-01_svg2__h",
    x1: 160.75,
    x2: 652.75,
    y1: 475.01,
    y2: 80.01
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_sferics-01_svg2__a",
    id: "probability_sferics-01_svg2__i",
    x1: 209.05,
    x2: 701.05,
    y1: 535.18,
    y2: 140.18
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_sferics-01_svg2__a",
    id: "probability_sferics-01_svg2__j",
    x1: 231.24,
    x2: 723.24,
    y1: 562.82,
    y2: 167.82
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_sferics-01_svg2__a",
    id: "probability_sferics-01_svg2__k",
    x1: 164.62,
    x2: 656.62,
    y1: 479.83,
    y2: 84.83
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_sferics-01_svg2__a",
    id: "probability_sferics-01_svg2__l",
    x1: 186.86,
    x2: 678.86,
    y1: 507.54,
    y2: 112.54
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_sferics-01_svg2__a",
    id: "probability_sferics-01_svg2__m",
    x1: 352.16,
    x2: 844.16,
    y1: 713.43,
    y2: 318.43
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_sferics-01_svg2__a",
    id: "probability_sferics-01_svg2__n",
    x1: 281.63,
    x2: 773.63,
    y1: 625.58,
    y2: 230.58
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_sferics-01_svg2__a",
    id: "probability_sferics-01_svg2__o",
    x1: 239.33,
    x2: 731.33,
    y1: 572.89,
    y2: 177.89
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_sferics-01_svg2__a",
    id: "probability_sferics-01_svg2__p",
    x1: 322.41,
    x2: 814.41,
    y1: 676.38,
    y2: 281.38
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_sferics-01_svg2__a",
    id: "probability_sferics-01_svg2__q",
    x1: 280.48,
    x2: 772.48,
    y1: 624.15,
    y2: 229.15
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_sferics-01_svg2__a",
    id: "probability_sferics-01_svg2__r",
    x1: 156.94,
    x2: 648.94,
    y1: 470.27,
    y2: 75.27
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_sferics-01_svg2__a",
    id: "probability_sferics-01_svg2__s",
    x1: 300.22,
    x2: 792.22,
    y1: 648.74,
    y2: 253.74
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_sferics-01_svg2__a",
    id: "probability_sferics-01_svg2__t",
    x1: 329.97,
    x2: 821.97,
    y1: 685.79,
    y2: 290.79
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#probability_sferics-01_svg2__a",
    id: "probability_sferics-01_svg2__u",
    x1: 239.7,
    x2: 731.7,
    y1: 573.35,
    y2: 178.35
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M171.78 0C76.91 0 0 76.91 0 171.78s76.91 171.78 171.78 171.78 171.78-76.91 171.78-171.78S266.65 0 171.78 0M75.39 143.18q-6.15-10.2-6.15-22.8c0-12.6 2.07-16.3 6.23-23.1q6.225-10.2 16.5-16.05c6.85-3.9 14.32-5.85 22.42-5.85s15.7 2 22.5 6 12.23 9.4 16.27 16.2c4.05 6.8 6.08 14.4 6.08 22.8s-2.08 16.15-6.23 22.95-9.63 12.15-16.42 16.05q-10.2 5.85-22.2 5.85c-12 0-15.73-1.97-22.57-5.92-6.85-3.95-12.33-9.32-16.43-16.13m55.5 141h-42.3l121.2-210h42.3zm134.47-23.4c-4.05 6.8-9.5 12.23-16.35 16.28s-14.43 6.08-22.73 6.08-15.85-2.07-22.65-6.23q-10.2-6.225-16.2-16.5c-4-6.85-6-14.22-6-22.12 0-8.6 2.07-16.3 6.22-23.1s9.65-12.17 16.5-16.12 14.22-5.92 22.12-5.92q12.9 0 23.1 6.3c6.8 4.2 12.17 9.73 16.12 16.58s5.93 14.28 5.93 22.27-2.03 15.7-6.08 22.5Z",
    style: {
      fill: "url(#probability_sferics-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.29 218.18q-8.1 0-13.95 5.85t-5.85 14.25c0 8.4 1.95 10.05 5.85 13.95q5.85 5.85 13.95 5.85c8.1 0 10.35-1.95 14.25-5.85q5.85-5.85 5.85-13.95c0-8.1-1.95-10.35-5.85-14.25q-5.85-5.85-14.25-5.85",
    style: {
      fill: "url(#probability_sferics-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.39 140.18c5.4 0 10.05-1.92 13.95-5.77s5.85-8.52 5.85-14.02-1.95-10.3-5.85-14.1q-5.85-5.7-13.95-5.7c-8.1 0-10.23 1.9-14.17 5.7-3.95 3.8-5.93 8.5-5.93 14.1s1.97 10.18 5.93 14.02c3.95 3.85 8.67 5.77 14.17 5.77",
    style: {
      fill: "url(#probability_sferics-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.59 515.9a8 8 0 0 0-10.93 2.93l-16.83 29.16a7.998 7.998 0 0 0 6.92 12 8.01 8.01 0 0 0 6.94-4l16.84-29.16c2.21-3.83.9-8.72-2.93-10.93Z",
    style: {
      fill: "url(#probability_sferics-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.97 515.9a8 8 0 0 0-10.93 2.93l-16.84 29.16a8 8 0 0 0 2.93 10.93c1.26.73 2.63 1.07 3.99 1.07 2.77 0 5.45-1.43 6.94-4l16.84-29.16c2.21-3.83.9-8.72-2.93-10.93",
    style: {
      fill: "url(#probability_sferics-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.59 515.9a8 8 0 0 0-10.93 2.93l-16.84 29.16a7.998 7.998 0 0 0 6.92 12c2.77 0 5.45-1.43 6.94-4l16.84-29.16c2.21-3.83.9-8.72-2.93-10.93",
    style: {
      fill: "url(#probability_sferics-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.21 515.9c-3.82-2.21-8.72-.9-10.93 2.93l-16.84 29.16a7.998 7.998 0 0 0 6.92 12 8.01 8.01 0 0 0 6.94-4l16.84-29.16c2.21-3.83.9-8.72-2.93-10.93",
    style: {
      fill: "url(#probability_sferics-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.37 235.26c6.95 2.36 13.48 6.12 19.02 11.14a8.003 8.003 0 0 0 13.36-5.27c3.61-44.21 42.54-77.62 86.79-74.5 44.24 3.13 78.09 41.69 75.44 85.97-.13 2.2.65 4.36 2.16 5.96a7.98 7.98 0 0 0 5.82 2.52c7.05 0 14.05.97 20.79 2.88 4.25 1.2 8.67-1.26 9.88-5.51 1.2-4.25-1.27-8.67-5.52-9.88a92.5 92.5 0 0 0-17.01-3.13c-.51-22.82-8.93-44.54-24.15-61.88-17.01-19.39-40.55-31.07-66.29-32.89-25.73-1.82-50.68 6.43-70.25 23.23-16.06 13.79-26.98 32.03-31.54 52.34a71 71 0 0 0-13.1-6.02c-1.6 5.1-3.4 10.11-5.38 15.04Z",
    style: {
      fill: "url(#probability_sferics-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.81 462.78-12.98 22.48a7.998 7.998 0 0 0 6.92 12c2.77 0 5.45-1.43 6.94-4l12.98-22.48c2.21-3.83.9-8.72-2.93-10.93a8 8 0 0 0-10.93 2.93",
    style: {
      fill: "url(#probability_sferics-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.42 462.78-12.98 22.48a8 8 0 0 0 2.93 10.93c1.26.73 2.63 1.07 3.99 1.07 2.77 0 5.45-1.43 6.94-4l12.98-22.48c2.21-3.83.9-8.72-2.93-10.93a8 8 0 0 0-10.93 2.93",
    style: {
      fill: "url(#probability_sferics-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.13 430.63h74.95c4.42 0 8-3.58 8-8s-3.58-8-8-8h-74.89c-29.24-.23-53.03-24.21-53.03-53.45 0-2.34.17-4.65.47-6.92-5.38 1.78-10.85 3.33-16.41 4.67-.02.75-.05 1.5-.05 2.25 0 38 30.91 69.15 68.97 69.45Z",
    style: {
      fill: "url(#probability_sferics-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.19 462.78-12.98 22.48a8 8 0 0 0 2.93 10.93c1.26.73 2.63 1.07 3.99 1.07 2.77 0 5.45-1.43 6.94-4l12.98-22.48c2.21-3.83.9-8.72-2.93-10.93a8 8 0 0 0-10.93 2.93",
    style: {
      fill: "url(#probability_sferics-01_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.82 515.9a8 8 0 0 0-10.93 2.93l-16.84 29.16a7.998 7.998 0 0 0 6.92 12c2.77 0 5.45-1.43 6.94-4l16.83-29.16c2.21-3.83.9-8.72-2.93-10.93Z",
    style: {
      fill: "url(#probability_sferics-01_svg2__m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.1 339.01v-54.46c0-4.42-3.58-8-8-8s-8 3.58-8 8v54.46c-15.7 3.64-27.44 17.73-27.44 34.52 0 19.54 15.9 35.44 35.44 35.44s35.44-15.9 35.44-35.44c0-16.79-11.74-30.88-27.44-34.52m-8 53.96c-10.72 0-19.44-8.72-19.44-19.44s8.72-19.44 19.44-19.44 19.44 8.72 19.44 19.44-8.72 19.44-19.44 19.44",
    style: {
      fill: "url(#probability_sferics-01_svg2__n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.68 320.13V116.56c0-27.34-22.24-49.58-49.58-49.58s-49.58 22.24-49.58 49.58v203.57a72.68 72.68 0 0 0-23.29 53.39c0 40.18 32.69 72.86 72.86 72.86s72.86-32.69 72.86-72.86c0-20.36-8.44-39.61-23.29-53.39Zm-83.16-203.57c0-18.52 15.06-33.58 33.58-33.58s33.58 15.06 33.58 33.58v6.13h-67.16zm90.45 256.97c0 31.35-25.51 56.86-56.86 56.86s-56.86-25.51-56.86-56.86c0-16.89 7.44-32.8 20.42-43.65a8 8 0 0 0 2.87-6.14V138.69h67.16v17.68h-9.88c-4.42 0-8 3.58-8 8s3.58 8 8 8h9.88v23.92h-9.88c-4.42 0-8 3.58-8 8s3.58 8 8 8h9.88v23.92h-9.88c-4.42 0-8 3.58-8 8s3.58 8 8 8h9.88v71.54a8 8 0 0 0 2.87 6.14c12.98 10.85 20.42 26.76 20.42 43.65Z",
    style: {
      fill: "url(#probability_sferics-01_svg2__o)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.98 497.26c2.77 0 5.45-1.43 6.94-4l12.98-22.48c2.21-3.83.9-8.72-2.93-10.93a8 8 0 0 0-10.93 2.93l-12.98 22.48a8 8 0 0 0 2.93 10.93c1.26.73 2.64 1.07 3.99 1.07",
    style: {
      fill: "url(#probability_sferics-01_svg2__p)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.87 420.14c-.73-4.36-4.86-7.29-9.22-6.56-4.17.7-8.45 1.06-12.7 1.06h-35.51c-4.42 0-8 3.58-8 8s3.58 8 8 8h35.51c5.14 0 10.31-.43 15.35-1.28 4.36-.73 7.3-4.86 6.56-9.22Z",
    style: {
      fill: "url(#probability_sferics-01_svg2__q)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.34 235.29c.68 0 1.38-.09 2.08-.28 4.27-1.14 6.8-5.53 5.66-9.8-6.45-24.08-27.37-40.73-53.29-42.4a8.014 8.014 0 0 0-8.5 7.47 8.01 8.01 0 0 0 7.47 8.5c19.25 1.24 34.15 12.96 38.87 30.58a8 8 0 0 0 7.72 5.93Z",
    style: {
      fill: "url(#probability_sferics-01_svg2__r)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.36 497.26c2.77 0 5.45-1.43 6.94-4l12.98-22.48c2.21-3.83.9-8.72-2.93-10.93a8 8 0 0 0-10.93 2.93l-12.98 22.48a8 8 0 0 0 2.93 10.93c1.26.73 2.64 1.07 3.99 1.07",
    style: {
      fill: "url(#probability_sferics-01_svg2__s)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.2 515.9a8 8 0 0 0-10.93 2.93l-16.84 29.16a7.998 7.998 0 0 0 6.92 12c2.77 0 5.45-1.43 6.94-4l16.83-29.16c2.21-3.83.9-8.72-2.93-10.93Z",
    style: {
      fill: "url(#probability_sferics-01_svg2__t)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.15 420.59c-1.56-4.75-5.23-8.22-10.05-9.51l-36.67-9.83 25.2-94.05c1.36-5.08-.96-10.27-5.65-12.64s-10.25-1.16-13.53 2.95l-94.93 118.88c-3.12 3.91-4.01 8.87-2.45 13.62s5.23 8.22 10.05 9.51l36.67 9.83-25.2 94.05c-1.36 5.07.96 10.27 5.65 12.64 1.6.81 3.31 1.2 4.99 1.2 3.23 0 6.38-1.45 8.54-4.15l94.93-118.88c3.12-3.91 4.01-8.87 2.45-13.62m-16.33 5.37-78.55 98.36 19.35-72.24c1.01-3.75.49-7.67-1.46-11.04s-5.08-5.78-8.83-6.78l-35.93-9.63 78.55-98.36-19.35 72.24c-1 3.75-.49 7.67 1.46 11.04s5.08 5.78 8.83 6.78z",
    style: {
      fill: "url(#probability_sferics-01_svg2__u)"
    }
  }));
};
export default SvgProbabilitySferics01;